import React from "react";
import styles from "./Lifestyle.module.sass";
import Hero from "./Hero";
import Community from "../../components/Community";

const Lifestyle = () => {
  return (
    <>
      <Hero />
      <Community />
    </>
  );
};

export default Lifestyle;
